import { filmGenres, filmRegions } from '@/mocks/films';

interface FilterBarProps {
  type: string;
  genre: string;
  region: string;
  year: string;
  sort: string;
  onType: (v: string) => void;
  onGenre: (v: string) => void;
  onRegion: (v: string) => void;
  onYear: (v: string) => void;
  onSort: (v: string) => void;
  onReset: () => void;
}

const typeOptions = [
  { value: 'all', label: '全部' },
  { value: 'movie', label: '电影' },
  { value: 'series', label: '电视剧' },
];
const yearOptions = ['全部', '2025', '2024', '2023', '2022'];
const sortOptions = [
  { value: 'heat', label: '热度优先' },
  { value: 'rating', label: '评分优先' },
  { value: 'year', label: '最新上线' },
];

function Chip({ active, label, onClick }: { active: boolean; label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'px-3 py-1.5 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer',
        active
          ? 'bg-primary-500 text-background-50'
          : 'bg-background-100 text-foreground-600 border border-background-200 hover:border-primary-300',
      ].join(' ')}
    >
      {label}
    </button>
  );
}

function Group({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 py-3 border-b border-background-200 last:border-0">
      <span className="shrink-0 text-sm text-foreground-500 font-medium sm:w-16 sm:pt-1.5">{label}</span>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

export default function FilterBar(props: FilterBarProps) {
  const { type, genre, region, year, sort } = props;
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 px-4 md:px-5">
      <Group label="类型">
        {typeOptions.map((o) => (
          <Chip key={o.value} label={o.label} active={type === o.value} onClick={() => props.onType(o.value)} />
        ))}
      </Group>
      <Group label="题材">
        <Chip label="全部" active={genre === '全部'} onClick={() => props.onGenre('全部')} />
        {filmGenres.map((g) => (
          <Chip key={g} label={g} active={genre === g} onClick={() => props.onGenre(g)} />
        ))}
      </Group>
      <Group label="地区">
        <Chip label="全部" active={region === '全部'} onClick={() => props.onRegion('全部')} />
        {filmRegions.map((r) => (
          <Chip key={r} label={r} active={region === r} onClick={() => props.onRegion(r)} />
        ))}
      </Group>
      <Group label="年份">
        {yearOptions.map((y) => (
          <Chip key={y} label={y} active={year === y} onClick={() => props.onYear(y)} />
        ))}
      </Group>
      <Group label="排序">
        {sortOptions.map((s) => (
          <Chip key={s.value} label={s.label} active={sort === s.value} onClick={() => props.onSort(s.value)} />
        ))}
        <button
          type="button"
          onClick={props.onReset}
          className="flex items-center gap-1 px-3 py-1.5 rounded-md text-sm text-accent-600 hover:bg-accent-50 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line" />
          重置筛选
        </button>
      </Group>
    </div>
  );
}